import { Icon } from '@iconify/react';
import appleFilled from '@iconify/icons-ant-design/apple-filled';
// material
import { alpha, styled } from '@mui/material/styles';
import { Button, Card, Typography, Box } from '@mui/material';
// utils
import { fNumber, fShortenNumber } from '../../../utils/formatNumber';
import ReactGA from 'react-ga4';
import ImageSrc from '../../../utils/images/image6.png';

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(2, 2),
  color: '#22577A',
  backgroundColor: '#ffffff',
  borderColor: theme.palette.primary.main,
  borderWidth: 5,
  height: 'auto',
  minHeight: 300,
  display: "flex",
  flexDirection: 'column',
  justifyContent: "center",
}));

// ----------------------------------------------------------------------
// AB1Percentage to take percentage of all patients receiving one antibiotic in previous 12months
const AB1Percentage = "27%";
// ABMore to take percentage of all patients receiving antibiotics for more than 3 days
const ABMorePercentage = "15%";

function AppNewUsers(props) {

  const category = "Dashboard " + props.user.dashboard;
  const dashNo = props.user.dashboard;

  const handleClick = () => {
    const resistanceElement = document.getElementById('duration');
    if (resistanceElement) {
      resistanceElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <RootStyle>
      <Box
        sx={{
          height: 'auto',
          minHeight: 280,
          border: 1,
          borderRadius: 2,
          borderColor: "secondary",
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          alignItems: 'center',
          boxSizing: 'border-box',
        }}
      >

      <Box component="img" src={ImageSrc} sx={{marginTop:2, width: 70, height: 70 }} />
     
      <Typography 
          variant="h5" 
          mt={1} 
          color='#aa3377' 
        >
          {fNumber(props.model.resistace ? props.model.resistace : 0)}%
      </Typography>
      <Typography variant="subtitle2" style={{ fontSize: '95%' }}>
      Of pathogens showed resistance to antibiotics.
      </Typography>
        <br />
        <Button
          fullWidth
          style={{ boxShadow: 'none', marginTop: '5%', whiteSpace: 'nowrap' }}
          variant="contained"
          color='secondary'
          onClick={handleClick}
        >
          See more on resistance
        </Button>
      </Box>
    </RootStyle>
  );
}

import { connect } from "react-redux";
const mapState = state => ({
  model: state.antibiotics.ab,
  user: state.user
});

const mapDispatch = ({
  antibiotics: { getGeneralAB }
}) => ({
  getGeneralAB: () => getGeneralAB()
});

export default connect(mapState, mapDispatch)(AppNewUsers);
